module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide2#toc2"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("ANF\tAnte-­­Nicene Fathers")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("BDAG\tW. Bauer, F. W. Danker, W. F. Arndt, and F. W. Gingrich, ")]), _c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("A Greek–English Lexicon of the New Testament and Other Early Christian Literature, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("3rd ed. (Chicago: University of Chicago Press, 2003)")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("EKKNT\tEvangelisch-­katholischer Kommentar zum Neuen Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("HR\tE. Hatch and H. A. Redpath, ")]), _c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("A Concordance to the Septuagint,")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" 2nd ed. (Grand Rapids: Baker Academic, 1998)")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ICC\tInternational Critical Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("JBL\tJournal of Biblical Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("JPT\tJournal of Pentecostal Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("JPTSup\tJournal of Pentecostal Theology Supplement Series")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("JSNT\tJournal for the Study of the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("JTS\tJournal of Theological Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("LCC\tLibrary of Christian Classics")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("NCB\tNew Century Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("NICNT\tNew International Commentary on the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("NIDB\tNew Interpreter’s Dictionary of the Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("NIDOTTE\tNew International Dictionary of Old Testament Theology and Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("NIDPCM\tNew International Dictionary of Pentecostal and Charismatic Movements")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("NIGTC\tNew International Greek Testament Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("NPNF\tNicene and Post-­­Nicene Fathers")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("NTS\tNew Testament Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("PG\tPatrologia Graeca, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ed. J-P. Migne")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("PL\tPatrologia Latina, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ed. J-P. Migne")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("SBLDS\tSociety of Biblical Literature Dissertation Series")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("SBT\tStudies in Biblical Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("SJT\tScottish Journal of Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("SNTSM\tStudiorum Novi Testamenti Societas Monographs")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("TDNT\tTheological Dictionary of the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic CharOverride-2"
  }, [_vm._v("TDOT\tTheological Dictionary of the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("WUNT\tWissenschaftliche Untersuchungen zum Neuen Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("WUNT/2\tWissenschaftliche Untersuchungen zum Neuen Testament, 2. Reihe")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56871017","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thiselton_A_Shorter_Guide-4.vue
// module id = 66
// module chunks = 0